<template>
	<div>
		<Fontnavbar title="下单成功"/>
		<div style="text-align: center;margin-top: 10px;">订单号：{{orderNo}}</div>
		<div class="order-success">
			<van-icon name="checked" size="100" />
			<div class="order-tip">下单成功</div>
		</div>
		<div class="order-btn">
			<van-button round block type="primary" @click="goPage('/order/detail?order_no='+orderNo)">订单详情</van-button>
		</div>
		<div class="order-btn">
			<van-button round block type="default" @click="goPage('/')">继续购物</van-button>
		</div>
		<div class="font">
      <div class="font_one">
        <div style="padding-left:6%">请扫码联系</div>
        <div>您的专属客服！</div>
        <div v-if="messag" style="font-size: 16px">微信：{{ messag.qq }}</div>
      </div>
      <div class="font_two">
         <van-image
   
                  width="120"
                  height="120"
                  :src="imgDomain+messag.wechat_img?imgDomain+messag.wechat_img:require('../../../public/static/ma.png')"
                />
      </div>
    </div>
		<div style="text-align: center;margin-top: 10px;">若已有客服微信，可不用重复添加！</div>
	</div>
</template>

<script>
import {
	Icon,
	Button
} from 'vant'
import Fontnavbar from "../../components/Navbar.vue";
import { post } from "../../request.js";
import {  get_customer } from "../../api.js";
import { Image as VanImage } from 'vant';
export default {
	components: {
		[Icon.name]: Icon,
		[Button.name]: Button,
		[VanImage.name]: VanImage,
		Fontnavbar
	},
	
  data() {
    return {
			imgDomain: process.env.VUE_APP_IMG_URL,
			orderNo: '',
			messag:[]
    };
  },
	
	mounted () {
		this.orderNo = this.$route.query.order_no
		post(get_customer, {}).then(res => {
			if (res.code == 200) {
                this.messag=res.data;
			} else{
				this.$message({
                  message: res.msg,
                  type: 'warning'
                  })
			}
			});
	},

  methods: {
		goPage(path) {
			this.$router.push({path: path});
		}
		
  }
	
}

</script>

<style lang="less" scoped>
.order-success{
	padding: 40px;
	text-align: center;
	color: #07c160;
}
.order-tip{
	font-size: 14px;
}
.order-btn{
	margin: 10px 20px;
}

.font{
display: flex;
background-color: #fff;
margin-top: 5%;
margin-left: 5%;
margin-right: 5%;
font-size: 20px;
border-radius: 8px;
height: 40%;
white-space: nowrap;
}

.font_one{
  padding-left: 10%;
  margin-top: 12%;
}

.font_two{
  padding-top: 2%;
  padding-right: 5%;
  padding-left: 5%;
  padding-bottom: 2%;
}

</style>
